import { v4 as uuidv4 } from 'uuid'

export default () => {
  const items = uuidv4().split('-')
  items.reverse()
  return items.pop()
}
